import React, { useState, useEffect } from "react";

import { faMailBulk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faGithub,
	faLinkedinIn,
	faFacebookF,
} from "@fortawesome/free-brands-svg-icons";
import { TypeAnimation } from 'react-type-animation';

import Logo from "../components/common/logo";
import Footer from "../components/common/footer";
import NavBar from "../components/common/navBar";
import Article from "../components/homepage/article";
import Works from "../components/homepage/works";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import myArticles from "../data/articles";

import "./styles/homepage.css";
import Socials from "../components/about/socials";

const Homepage = () => {
	const [stayLogo, setStayLogo] = useState(false);
	const [logoSize, setLogoSize] = useState(80);
	const [oldLogoSize, setOldLogoSize] = useState(80);

	useEffect(() => {
		document.title = INFO.main.title;
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		const handleScroll = () => {
			let scroll = Math.round(window.pageYOffset, 2);

			let newLogoSize = 80 - (scroll * 4) / 10;

			if (newLogoSize < oldLogoSize) {
				if (newLogoSize > 40) {
					setLogoSize(newLogoSize);
					setOldLogoSize(newLogoSize);
					setStayLogo(false);
				} else {
					setStayLogo(true);
				}
			} else {
				setLogoSize(newLogoSize);
				setStayLogo(false);
			}
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, [logoSize, oldLogoSize]);

	const logoStyle = {
		display: "flex",
		position: stayLogo ? "fixed" : "relative",
		top: stayLogo ? "5px" : "auto",
		zIndex: 999,
		border: stayLogo ? "1px solid white" : "none",
		borderRadius: stayLogo ? "50%" : "none",
		boxShadow: stayLogo ? "0px 4px 10px rgba(0, 0, 0, 0.25)" : "none",
	};

	return (
		<React.Fragment>
			<div className="page-content" id="home">
				<NavBar active="home" />
				<div className="content-wrapper">
					<div className="homepage-logo-container">
						<div style={ logoStyle }>
							<Logo width={ logoSize } link={ false } />
						</div>
					</div>

					<div className="homepage-container">
						<div className="homepage-first-area"
							style={ {
								backgroundImage: `url('bg-1.png')`,
								backgroundRepeat: "no-repeat",
								backgroundSize: "cover",
							} }>
							<div id="mask"></div>
							<div className="homepage-first-area-left-side">
								<div className="title homepage-title">
									{ INFO.homepage.title }
								</div>
								<TypeAnimation
									sequence={ ['MERN Stack Developer', 1000, 'Frontend Developer', 1000, 'React.js Developer', 1000] }
									//  Replacing previous Text
									wrapper="h1"
									repeat={ Infinity }
								/>
								<div className="subtitle homepage-subtitle">
									{ INFO.homepage.description }
								</div>



							</div>

							<div className="homepage-first-area-right-side">
								<div className="homepage-image-container">
									<div className="homepage-image-wrapper">
										<img
											src="homepage.jpg"
											alt="about"
											className="homepage-image"
										/>
									</div>
								</div>
							</div>
						</div>
						{/* Create a btn for download the resume */ }
						<div >
							<button className="resume-btn" >
								<a href="https://drive.google.com/file/d/12n1uEN7DwcokDv5TNcR54idY79ih2z09/view?usp=drive_link"
									target="_blank"
									rel="noreferrer"
									className="resume-btn-text"
								>	Get the resume
								</a>
							</button>
						</div>
						<div className="homepage-socials">
							<a
								href="https://github.com/omurRifat"
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									icon={ faGithub }
									className="homepage-social-icon"
								/>
							</a>
							<a
								href="https://www.linkedin.com/in/omurrifat/"
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									icon={ faLinkedinIn }
									className="homepage-social-icon"
								/>
							</a>
							<a
								href="https://www.facebook.com/OmurRifat"
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									icon={ faFacebookF }
									className="homepage-social-icon"
								/>
							</a>
							<a
								href={ `mailto:jabedomur.rifat@gmail.com` }
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									icon={ faMailBulk }
									className="homepage-social-icon"
								/>
							</a>
						</div>
						<div
							id="projects"
							style={ {
								backgroundImage: `url('hero-pattern-opacity.png')`,
								backgroundRepeat: "no-repeat",
								backgroundSize: "cover"
							} }
							className="projects-container mx-auto right-0">
							<div className="title projects-title">
								Things I’ve made trying to put my dent in the
								universe.
							</div>

							<div className="subtitle projects-subtitle">
								I've worked on a variety of projects over the years
								and I'm proud of the progress I've made. Many of
								these projects are open-source and available for
								others to explore and contribute to. If you're
								interested in any of the projects I've worked on,
								please feel free to check out the code and suggest
								any improvements or enhancements you might have in
								mind. Collaborating with others is a great way to
								learn and grow, and I'm always open to new ideas and
								feedback.
							</div>
							<div className="homepage-projects">
								<AllProjects />
							</div>
						</div>

						<div className="title articles-uper" id="articles">
							Articles I've written & Work Experience.
						</div>
						<div className="homepage-after-title"
							style={ {
								backgroundImage: `url('registration-bg.svg')`,
								backgroundRepeat: "no-repeat",
								backgroundSize: `cover`,
							} }>
							<div className="homepage-articles">
								{ myArticles.map((article, index) => (
									<div
										className="homepage-article"
										key={ (index + 1).toString() }
									>
										<Article
											key={ (index + 1).toString() }
											date={ article().date }
											title={ article().title }
											description={ article().description }
											link={ "https://medium.com/@jabedomur.rifat/a-learning-approach-for-graphql-e19266d3184e" }
										/>
									</div>
								)) }
							</div>

							<div className="homepage-works">
								<Works />
							</div>
						</div>

						<div className="contact-homepage" id="contact">
							<div className=""
								style={ {
									backgroundImage: `url("star-bg.svg")`,
									backgroundRepeat: "no-repeat",
									backgroundSize: "auto",
								} }
							>
								<div className="content-wrapper">
									<div className="contact-container">
										<div className="title contact-title">
											Let's Get in Touch: Ways to Connect with Me
										</div>

										<div className="subtitle contact-subtitle">
											Thank you for your interest in getting in touch with
											me. I welcome your feedback, questions, and
											suggestions. If you have a specific question or
											comment, please feel free to email me directly at
											&nbsp;{ " " }
											<a
												style={ {
													color: "#38BDF8",
													textDecoration: "underline",
												} } href={ `mailto:${INFO.main.email}` }>
												{ INFO.main.email }
											</a>
											. I make an effort to respond to all messages within
											24 hours, although it may take me longer during busy
											periods. Alternatively, you can use the contact form
											on my website to get in touch. Simply fill out the
											required fields and I'll get back to you as soon as
											possible. Finally, if you prefer to connect on
											social media, you can find me on{ " " }
											<a
												href={ INFO.socials.linkedin }
												target="_blank"
												rel="noreferrer"
												style={ {
													color: "#38BDF8",
													textDecoration: "underline",
												} }
											>
												LinkedIn
											</a>
											. I post regular updates and engage with my
											followers there, so don't hesitate to reach out.
											Thanks again for your interest, and I look forward
											to hearing from you!
										</div>
									</div>

									<div className="socials-container">
										<div className="contact-socials">
											<Socials />
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="page-footer">
							<Footer />
						</div>
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Homepage;
